export class HSPOpportunityStudentContactPersonView implements IHSPOpportunityStudentContactPersonView {
  dateCreated?: Date | undefined;
  dateUpdated?: Date | undefined;
  createdByUserId?: string | undefined;
  updatedByUserId?: string | undefined;
  contactPersonId?: string | undefined;

  constructor(data?: IHSPOpportunityStudentContactPersonView) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.dateCreated = Data["dateCreated"] ? new Date(Data["dateCreated"].toString()) : <any>undefined;
      this.dateUpdated = Data["dateUpdated"] ? new Date(Data["dateUpdated"].toString()) : <any>undefined;
      this.createdByUserId = Data["createdByUserId"];
      this.updatedByUserId = Data["updatedByUserId"];
      this.contactPersonId = Data["contactPersonId"];
    }
  }

  static fromJS(data: any): HSPOpportunityStudentContactPersonView {
    data = typeof data === 'object' ? data : {};
    let result = new HSPOpportunityStudentContactPersonView();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
    data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : <any>undefined;
    data["createdByUserId"] = this.createdByUserId;
    data["updatedByUserId"] = this.updatedByUserId;
    data["contactPersonId"] = this.contactPersonId;
    return data;
  }
}

export interface IHSPOpportunityStudentContactPersonView {
  dateCreated?: Date | undefined;
  dateUpdated?: Date | undefined;
  createdByUserId?: string | undefined;
  updatedByUserId?: string | undefined;
  contactPersonId?: string | undefined;
}